import React from 'react';

export const PublicFullscreenLayout = ({
  children,
  footer,
}: {
  children: React.ReactNode;
  footer: React.ReactNode;
}) => (
  <div className="h-screen flex flex-col justify-between">
    <div className="flex-1">{children}</div>
    {/* Most likely a public footer will be needed */}
    {footer}
  </div>
);
